import InterviewsApp from './InterviewsApp.vue'
import NewGradList from './pages/NewGradList.vue'
import InterviewsList from './pages/InterviewsList.vue'

export default {
  path: '/Interviews',
  component: InterviewsApp,
  children: [
    {
      path: '/InterviewsList',
      name: 'InterviewsList',
      component: InterviewsList,
      meta: { requiresAuth: true, title: 'RP - 面接一覧' }
    },
    {
      path: '/NewGradList',
      name: 'NewGradList',
      component: NewGradList,
      meta: { requiresAuth: true, title: 'RP - 新卒集計' }
    }
  ]
}
